import styled from 'styled-components';

export const TableData = styled.td`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: inherit;
`;
